import { WT_SURVEY_LS_KEY } from './constants';

// localStorage is the source of truth. Wrapped because Safari private mode and
// embedded webviews can throw on localStorage access itself, not just getItem.

export const shouldShowWtSurvey = (): boolean => {
  try {
    return window.localStorage.getItem(WT_SURVEY_LS_KEY) === null;
  } catch {
    // Fail closed: showing twice is worse than not showing.
    return false;
  }
};

export const markWtSurveySeen = (): void => {
  try {
    // Written on shown, so a reload after seeing it does not show it again.
    window.localStorage.setItem(WT_SURVEY_LS_KEY, '1');
  } catch {
    // The modal is already up; nothing here is worth surfacing.
  }
};
